"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/camelcase */
var oidc_client_1 = require("oidc-client");
var EnumRole_1 = require("./EnumRole");
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService(config) {
        var _this = this;
        var _a;
        this.onLoginRequired = [];
        this.currentUser = null;
        this.onCurrentUserLoaded = undefined;
        var settings = {
            authority: config.stsAuthority,
            client_id: config.clientId,
            redirect_uri: config.clientRoot + "login",
            silent_redirect_uri: config.clientRoot + "silentLogin",
            post_logout_redirect_uri: "" + config.clientRoot,
            response_type: 'id_token token',
            revokeAccessTokenOnSignout: true,
            loadUserInfo: true,
            automaticSilentRenew: false,
            scope: config.clientScope,
        };
        this.defaultPath = (_a = config.defaultPath) !== null && _a !== void 0 ? _a : './';
        this.mainPage = config.clientRoot;
        this.logoutSync = config.logoutSync;
        this.userManager = new oidc_client_1.UserManager(settings);
        this.userManager.events.addUserLoaded(function (user) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setCurrentUser(user)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        this.userManager.events.addUserSignedOut(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // eslint-disable-next-line no-console
                        console.log("receive addUserSignedOut event");
                        if (!this.logoutSync) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.logout()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        this.userManager.events.addUserUnloaded(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // eslint-disable-next-line no-console
                console.log("receive addUserUnloaded");
                this.setCurrentUser(undefined);
                return [2 /*return*/];
            });
        }); });
        this.userManager.events.addAccessTokenExpiring(function () {
            _this.onAccessTokenExpiring();
        });
        this.setCurrentUser(); // Set the current if it exist
        oidc_client_1.Log.logger = console;
        oidc_client_1.Log.level = oidc_client_1.Log.INFO;
    }
    AuthenticationService.prototype.addOnloginRequired = function (callback) {
        this.onLoginRequired.push(callback);
    };
    AuthenticationService.prototype.removeOnloginRequired = function (callback) {
        this.onLoginRequired = this.onLoginRequired.filter(function (ev) { return ev !== callback; });
    };
    Object.defineProperty(AuthenticationService.prototype, "currentUserRoles", {
        get: function () {
            return (AuthenticationService.getUserRoles(this.currentUser));
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationService.prototype.clearStaleState = function () {
        // prevent Error: No matching state found in storage,
        // which can happen due to duplicate state entries
        return this.userManager.clearStaleState();
    };
    AuthenticationService.prototype.onAccessTokenExpiring = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUser()];
                    case 1:
                        user = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        if (!user) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.renewToken()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        if (error_1.message === 'login_required') {
                            this.onLoginRequired.forEach(function (ev) { return ev(); });
                            if (user === null || user === void 0 ? void 0 : user.expires_in) {
                                setTimeout(function () {
                                    _this.login();
                                }, (user === null || user === void 0 ? void 0 : user.expires_in) * 1000);
                            }
                            else {
                                this.login();
                            }
                        }
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationService.getUserFromStorage = function () {
        var data = localStorage.getItem('USER_DATA');
        if (data) {
            var userData = new oidc_client_1.User(JSON.parse(data));
            if (userData && userData.expired === false) {
                return userData;
            }
        }
        return null;
    };
    AuthenticationService.prototype.setCurrentUser = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var newUser;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newUser = user;
                        if (!!user) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.userManager.getUser()];
                    case 1:
                        newUser = (_a.sent());
                        _a.label = 2;
                    case 2:
                        if (newUser) {
                            this.currentUser = newUser;
                            localStorage.setItem('USER_DATA', JSON.stringify(newUser));
                            if (this.onCurrentUserLoaded) {
                                this.onCurrentUserLoaded(newUser);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationService.prototype.getUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.currentUser && !this.currentUser.expired) {
                            return [2 /*return*/, this.currentUser];
                        }
                        return [4 /*yield*/, this.userManager.getUser()];
                    case 1:
                        user = (_a.sent());
                        if (!user || user.expired) {
                            this.currentUser = null;
                            return [2 /*return*/, null];
                        }
                        this.currentUser = user;
                        return [2 /*return*/, user];
                }
            });
        });
    };
    AuthenticationService.prototype.login = function (url) {
        var redirectUrl = url;
        if (!redirectUrl) {
            var location_1 = window.location;
            redirectUrl = location_1.pathname + location_1.search;
        }
        localStorage.setItem('REQUEST_URL', redirectUrl);
        return this.userManager.signinRedirect();
    };
    AuthenticationService.prototype.loginCallback = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var requestUrl, newUser, error_2, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestUrl = localStorage.getItem('REQUEST_URL');
                        // remove orphan OIDC state, To prevent the Error: No matching state found in storage,
                        // eslint-disable-next-line no-console
                        this.clearStaleState().then(function () { console.log('clearStaleState success'); }).catch(function () { console.log('clearStaleState failed'); });
                        if (!!requestUrl) return [3 /*break*/, 2];
                        // eslint-disable-next-line no-console
                        console.log('no REQUEST_URL, navigate to main page.');
                        return [4 /*yield*/, this.login(this.mainPage)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, (null)];
                    case 2:
                        _a.trys.push([2, 4, , 6]);
                        return [4 /*yield*/, this.userManager.signinRedirectCallback(url)];
                    case 3:
                        newUser = _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        error_2 = _a.sent();
                        console.error(error_2);
                        return [4 /*yield*/, this.login(this.mainPage)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/, (null)];
                    case 6:
                        _a.trys.push([6, 9, , 10]);
                        if (!newUser) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.setCurrentUser(newUser)];
                    case 7:
                        _a.sent();
                        document.location.href = requestUrl !== null && requestUrl !== void 0 ? requestUrl : this.defaultPath;
                        localStorage.removeItem('REQUEST_URL');
                        return [2 /*return*/, newUser];
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        error_3 = _a.sent();
                        console.error(error_3);
                        return [3 /*break*/, 10];
                    case 10: return [2 /*return*/, (null)];
                }
            });
        });
    };
    AuthenticationService.prototype.signinSilentCallback = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.userManager.signinSilentCallback(url)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.setCurrentUser()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        console.error(error_4);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationService.prototype.refreshToken = function () {
        return this.renewToken();
    };
    AuthenticationService.prototype.renewToken = function () {
        return this.userManager.signinSilent();
    };
    AuthenticationService.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, reason_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // eslint-disable-next-line no-console
                        console.log('logout() is called');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.getUser()];
                    case 2:
                        user = _a.sent();
                        localStorage.removeItem('USER_DATA');
                        localStorage.removeItem('TaxpayerNameAR');
                        localStorage.removeItem('TaxpayerNameEN');
                        return [4 /*yield*/, this.userManager.removeUser().catch(function (reason) {
                                console.error(reason);
                            })];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        reason_1 = _a.sent();
                        console.error(reason_1);
                        return [3 /*break*/, 5];
                    case 5:
                        if (!user) return [3 /*break*/, 7];
                        this.setCurrentUser(undefined);
                        return [4 /*yield*/, this.userManager
                                .signoutRedirect({ id_token_hint: user && user.id_token })
                                .then(function () {
                                // eslint-disable-next-line no-console
                                console.log('signoutRedirect success');
                            })
                                .catch(function (reason) {
                                console.error(reason);
                            })];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        // eslint-disable-next-line no-console
                        console.log('user not found for logout.');
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationService.prototype.ensureLogin = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var currentUser, userFromStorage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userManager.getUser()];
                    case 1:
                        currentUser = (_a.sent());
                        if (!!currentUser) return [3 /*break*/, 3];
                        userFromStorage = AuthenticationService.getUserFromStorage();
                        if (!userFromStorage) return [3 /*break*/, 3];
                        this.userManager.storeUser(userFromStorage);
                        return [4 /*yield*/, this.userManager.getUser()];
                    case 2:
                        currentUser = (_a.sent());
                        _a.label = 3;
                    case 3:
                        if (!(!currentUser || currentUser.expired)) return [3 /*break*/, 5];
                        this.currentUser = null;
                        return [4 /*yield*/, this.login(url)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/, false];
                    case 5:
                        this.currentUser = currentUser;
                        return [2 /*return*/, true];
                }
            });
        });
    };
    AuthenticationService.getUserRoles = function (user) {
        var roles = [];
        if (user) {
            var userProfile = user.profile;
            if (userProfile.IsTaxAdmin === '0') {
                roles.push(EnumRole_1.UserRole.NormalDelegate);
            }
            else if (userProfile.IsTaxAdmin === '1') {
                roles.push(EnumRole_1.UserRole.AdminDelegate);
            }
            if (userProfile.EtaEmp === '1') {
                if (userProfile.role) {
                    if (Array.isArray(userProfile.role)) {
                        // if user an Eta employee then load the role from the token
                        // eslint-disable-next-line no-restricted-syntax
                        for (var _i = 0, _a = userProfile.role.map(function (r) { return EnumRole_1.UserRole[r]; }); _i < _a.length; _i++) {
                            var userRole = _a[_i];
                            roles.push(userRole);
                        }
                    }
                    else if (typeof userProfile.role === 'string') {
                        roles.push(EnumRole_1.UserRole[userProfile.role]);
                    }
                }
            }
        }
        return roles;
    };
    return AuthenticationService;
}());
exports.AuthenticationService = AuthenticationService;
//# sourceMappingURL=AuthenticationService.js.map